import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { Suspense, useEffect } from "react";

function App() {
  useEffect(() => {
    // 防止移动端页面被拖动
    const preventHorizontalScroll = (e: TouchEvent) => {
      const target = e.target as HTMLElement;
      // 如果不是Canvas元素，阻止默认的水平滚动
      if (!target.closest('canvas')) {
        if (Math.abs((e.touches[0] as any).clientX - (e.touches[0] as any).pageX) > 10) {
          e.preventDefault();
        }
      }
    };

    document.addEventListener('touchmove', preventHorizontalScroll, { passive: false });

    return () => {
      document.removeEventListener('touchmove', preventHorizontalScroll);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={
          <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
            <div className="text-center">
              <div className="w-24 h-24 md:w-32 md:h-32 flex items-center justify-center mx-auto mb-4 animate-pulse">
                <img 
                  src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f90798bf81b405c7efd97c32526a4406.png"
                  alt="加载中"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="text-[10px] text-[#E5E4E2] opacity-50 tracking-widest">
                加载中...
              </div>
            </div>
          </div>
        }>
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
